'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _getErrorEmailHref = require('../utils/getErrorEmailHref');

var _getErrorEmailHref2 = _interopRequireDefault(_getErrorEmailHref);

var _navigationActions = require('../../../../reducers/navigationActions');

var _FullScreenErrorModal = require('../../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

var _notificationConstants = require('../../../../../common/notifications/notificationConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

// Constants


// Components


// Utils
// Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatchRefreshPage: function dispatchRefreshPage(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.refreshPage)());
        }
    };
};

var TimeoutErrorModal = function TimeoutErrorModal(_ref) {
    var error = _ref.error,
        boardId = _ref.boardId,
        currentUser = _ref.currentUser,
        dispatchRefreshPage = _ref.dispatchRefreshPage,
        close = _ref.close;

    var actions = [{ text: 'Refresh page', func: dispatchRefreshPage }];

    var emailConfig = {
        error: error,
        boardId: boardId,
        currentUser: currentUser,
        subject: 'Milanote page load issue',
        introduction: 'I encountered an issue while loading a Milanote page.'
    };

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        { close: close },
        _react2.default.createElement(
            'h2',
            null,
            'Something went wrong'
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                'For some reason it\'s taking an unusually long time to load your content. This often resolves itself after a few minutes \u2014 please try again soon.'
            ),
            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
        ),
        _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
                'p',
                null,
                'Contact',
                ' ',
                _react2.default.createElement(
                    'a',
                    { href: (0, _getErrorEmailHref2.default)(emailConfig) },
                    _notificationConstants.MILANOTE_EMAILS.SUPPORT
                ),
                ' ',
                'for more help.'
            )
        )
    );
};

TimeoutErrorModal.propTypes = {
    error: _propTypes2.default.object,
    boardId: _propTypes2.default.string,
    currentUser: _propTypes2.default.object,
    dispatchRefreshPage: _propTypes2.default.func,
    close: _propTypes2.default.func
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

exports.default = enhance(TimeoutErrorModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/components/TimeoutErrorModal.js
// module id = 1766
// module chunks = 0